import { useDispatch } from 'modules/react-redux';
import { uploadAttachments } from 'pages/requestForm/actions';
import { AttachmentKind } from 'pages/requestForm/data/AttachmentKind';
import { useCallback } from 'react';

import { getFileNameWithRequestId } from '../../NetSuiteRequestForm/NetSuiteRequestForm.helpers';

export const useUploadAttachments = (requestId: string) => {
    const dispatch = useDispatch();

    const onUploadAttachments = useCallback(
        (files: File[], attachmentKind: AttachmentKind) => {
            const filesWithRequestUuid = files.map((file) => {
                return new File([file], getFileNameWithRequestId(file.name, requestId), {
                    type: file.type,
                    lastModified: file.lastModified,
                });
            });

            dispatch(uploadAttachments({ files: filesWithRequestUuid, attachmentKind }));
        },
        [dispatch, requestId]
    );

    return {
        onUploadAttachments,
    };
};
